export default __webpack_public_path__ + "static/media/searching-data.591f3f12.png";